import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const BotaoLink = props => {
    const classes = useStyles();

    return (
        <Typography
            id={props.id}
            className={props.desabilitado ? `${classes.botaoLink} ${classes.botaoDesabilitado}` : classes.botaoLink}
            onClick={props.desabilitado ? () => void 0 : props.onClick}
        >
            {props.children}
        </Typography>
    );
}

const useStyles = makeStyles({
    botaoLink: {
        color: '#BF43AB',
        fontWeight: 'bold',
        float: 'right',
        marginRight: 0,
        cursor: 'pointer'
    },
    botaoDesabilitado: {
        color: 'rgba(0, 0, 0, 0.26)',
        cursor: 'default'
    }
});

BotaoLink.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

BotaoLink.defaultProps = {
    id: ''
};

export default BotaoLink;